import {
  getFingerprint as _getFingerprint,
  setOption,
} from '@thumbmarkjs/thumbmarkjs'
import { getLocalStorage, setLocalStorage } from './storage'

setOption('logging', false) // disable telemetric

let pending: Promise<void> | null = null
let primed = false

function canUseBrowserFingerprinting() {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined'
}

function computeFingerprint(): void {
  if (!canUseBrowserFingerprinting()) return
  if (pending || getLocalStorage('browser-id')) return
  pending = _getFingerprint()
    .then(fp => {
      setLocalStorage('browser-id', fp)
    })
    .catch(() => {
      // Swallow errors; allow retry on next getFingerprint() call
    })
    .finally(() => {
      pending = null
    })
}

export function primeFingerprint() {
  if (!canUseBrowserFingerprinting() || primed) return
  primed = true

  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => computeFingerprint())
  }
  window.setTimeout(() => computeFingerprint(), 3_000)
}

export function getFingerprint(): string | null {
  if (!canUseBrowserFingerprinting()) return null
  const id = getLocalStorage('browser-id')
  if (!id) computeFingerprint() // on-demand trigger (deduped by pending guard)
  return id
}
